import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HelpersService, ServiceRequestService } from 'src/app/services';
import { PartnerService } from '../../../../services/partner.service';
import { ChecklistService } from '../../../../services/checklist.service';
import { ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { ProductsService } from 'src/app/services/products.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-edit-services',
  templateUrl: './add-edit-services.component.html',
  styleUrls: ['./add-edit-services.component.scss'],
})
export class AddEditServicesComponent implements OnInit {
  @Input() selectedServiceType;
  @Input() categoryOptions;
  @Input() technicians;
  @Output() closeSidePanel = new EventEmitter();
  @Input() messageService;
  @Input() isFitting;

  public selectedTab = 1;
  public serviceType: any = {};
  public checklist: any = [];
  public timeOptions: any = [];

  public linkedSKUs: any = [];
  public editLine: any;
  public name: string;
  public duration: any;
  public allTech = false;
  public busy = false;
  public products: any = [];
  public newSku: any = null;
  public searchResult: any = [];
  public deleteLoading = false;
  public saveLoading = false;
  public serviceSKUPos = 0;
  public oldServiceSKU: any = {};
  editing: boolean;
  categoryError: boolean;
  nameError: boolean;
  durationError: boolean;
  costError: boolean;
  partnerId: any;
  partner: any;
  modules = {
    toolbar: [
      ['bold', 'italic', 'underline'], // toggled buttons
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
      ['clean'], // remove formatting button
    ],
  };

  public forSpecificDay: boolean = false;
  public forSpecificDate: boolean = false;
  public specificDay: any;
  public specificDate: string = '';
  public startTime: string = '';
  public endTime: string = '';
  public selectedOverrideTab = 1;
  public daysOfWeek = [
    {
      label: this.translate.instant('bikeshop.shop_profile.collections.monday'),
      value: 'Monday'
    },
    {
      label: this.translate.instant('bikeshop.shop_profile.collections.tuesday'),
      value: 'Tuesday'
    },
    {
      label: this.translate.instant('bikeshop.shop_profile.collections.wednesday'),
      value: 'Wednesday'
    },
    {
      label: this.translate.instant('bikeshop.shop_profile.collections.thursday'),
      value: 'Thursday'
    },
    {
      label: this.translate.instant('bikeshop.shop_profile.collections.friday'),
      value: 'Friday'
    },
    {
      label: this.translate.instant('bikeshop.shop_profile.collections.saturday'),
      value: 'Saturday'
    },
    {
      label: this.translate.instant('bikeshop.shop_profile.collections.sunday'),
      value: 'Sunday'
    }
  ];
  public configuredOverrides: any = [];

  constructor(
    public partnerService: PartnerService,
    public helpersService: HelpersService,
    public serviceRequest: ServiceRequestService,
    private confirmationService: ConfirmationService,
    private translate: TranslateService,
    private productsService: ProductsService,
    private checklistService: ChecklistService,
    public router: Router,
  ) { }

  ngOnInit() {
    this.categoryOptions = this.categoryOptions.map((x) => {
      return { label: x.name ? x.name : '', value: x.name ? x.name : '' };
    });

    this.serviceType = this.selectedServiceType;

    this.partnerId = this.helpersService.getPartnerId();
    this.partner = this.helpersService.getPartnerData();

    if (this.serviceType && this.serviceType.ID) {
      this.editing = true;
    } else {
      this.editing = false;
      this.allTech = true;
      if (this.isFitting) {
        this.serviceType.IsFitting = true;
        this.serviceType.Show = false;
      }
    }

    if (this.isFitting) {
      this.LoadFittingsTimeOptions();
      this.getOverrides();
    } else {
      this.LoadServiceTypeTimeOptions();
    }

    if (this.editing) {
      this.duration = this.timeOptions.find(
        (x) => x.value === this.serviceType.Hours,
      );

      this.partnerService
        .getSkusLinkedToServiceType(this.partnerId, this.serviceType.ID)
        .subscribe((linkedSKUs) => {
          this.linkedSKUs = linkedSKUs;
          this.oldServiceSKU = this.linkedSKUs[this.serviceSKUPos];
          this.linkedSKUs.forEach((element, i) => {
            if (element.IsService) {
              this.serviceSKUPos = i;
              this.oldServiceSKU = element.SKU;
            }
          });
        });
    } else {
      if (this.serviceType.Hours) {
        this.duration = this.timeOptions.find(
          (x) => x.value === this.serviceType.Hours,
        );
      }
    }

    if (this.editing) {
      let ids = this.serviceType.LinkedTechnicians.map((item) => {
        return item.ID;
      });
      this.technicians = this.technicians.map((technician) => {
        if (ids.length) {
          technician.Enabled = ids.indexOf(technician.ID) > -1;
        }
        return technician;
      });
      this.serviceRequest
        .getTechniciansForServiceType(this.serviceType.ID)
        .subscribe((linkedTechnicians) => {
          let ids = linkedTechnicians
            .filter((x) => {
              return x != null && x.ID;
            })
            .map((item) => {
              return item.ID;
            });
          this.technicians = this.technicians.map((technician) => {
            if (ids.length) {
              technician.Enabled = ids.indexOf(technician.ID) > -1;
            }
            return technician;
          });
        });
    } else {
      this.technicians = this.technicians.map((technician) => {
        technician.Enabled = true;
        return technician;
      });
    }
  }

  private LoadServiceTypeTimeOptions() {
    this.timeOptions = [
      { showValue: '0min', value: 0 },
      { showValue: '5min', value: 0.08 },
      { showValue: '10min', value: 0.17 },
      { showValue: '15min', value: 0.25 },
      { showValue: '20min', value: 0.33 },
      { showValue: '25min', value: 0.42 },
      { showValue: '30min', value: 0.5 },
      { showValue: '35min', value: 0.58 },
      { showValue: '40min', value: 0.67 },
      { showValue: '45min', value: 0.75 },
      { showValue: '50min', value: 0.83 },
      { showValue: '55min', value: 0.92 },
      { showValue: '1h', value: 1 },
      { showValue: '1h 05min', value: 1.08 },
      { showValue: '1h 10min', value: 1.17 },
      { showValue: '1h 15min', value: 1.25 },
      { showValue: '1h 20min', value: 1.33 },
      { showValue: '1h 25min', value: 1.42 },
      { showValue: '1h 30min', value: 1.5 },
      { showValue: '1h 35min', value: 1.58 },
      { showValue: '1h 40min', value: 1.67 },
      { showValue: '1h 45min', value: 1.75 },
      { showValue: '1h 50min', value: 1.83 },
      { showValue: '1h 55min', value: 1.92 },
      { showValue: '2h', value: 2 },
      { showValue: '2h 05min', value: 2.08 },
      { showValue: '2h 10min', value: 2.17 },
      { showValue: '2h 15min', value: 2.25 },
      { showValue: '2h 20min', value: 2.33 },
      { showValue: '2h 25min', value: 2.42 },
      { showValue: '2h 30min', value: 2.5 },
      { showValue: '2h 35min', value: 2.58 },
      { showValue: '2h 40min', value: 2.67 },
      { showValue: '2h 45min', value: 2.75 },
      { showValue: '2h 50min', value: 2.83 },
      { showValue: '2h 55min', value: 2.92 },
      { showValue: '3h', value: 3 },
      { showValue: '3h 05min', value: 3.08 },
      { showValue: '3h 10min', value: 3.17 },
      { showValue: '3h 15min', value: 3.25 },
      { showValue: '3h 20min', value: 3.33 },
      { showValue: '3h 25min', value: 3.42 },
      { showValue: '3h 30min', value: 3.5 },
      { showValue: '3h 35min', value: 3.58 },
      { showValue: '3h 40min', value: 3.67 },
      { showValue: '3h 45min', value: 3.75 },
      { showValue: '3h 50min', value: 3.83 },
      { showValue: '3h 55min', value: 3.92 },
      { showValue: '4h', value: 4 },
      { showValue: '4h 05min', value: 4.08 },
      { showValue: '4h 10min', value: 4.17 },
      { showValue: '4h 15min', value: 4.25 },
      { showValue: '4h 20min', value: 4.33 },
      { showValue: '4h 25min', value: 4.42 },
      { showValue: '4h 30min', value: 4.5 },
      { showValue: '4h 35min', value: 4.58 },
      { showValue: '4h 40min', value: 4.67 },
      { showValue: '4h 45min', value: 4.75 },
      { showValue: '4h 50min', value: 4.83 },
      { showValue: '4h 55min', value: 4.92 },
      { showValue: '5h', value: 5 },
      { showValue: '5h 05min', value: 5.08 },
      { showValue: '5h 10min', value: 5.17 },
      { showValue: '5h 15min', value: 5.25 },
      { showValue: '5h 20min', value: 5.33 },
      { showValue: '5h 25min', value: 5.42 },
      { showValue: '5h 30min', value: 5.5 },
      { showValue: '5h 35min', value: 5.58 },
      { showValue: '5h 40min', value: 5.67 },
      { showValue: '5h 45min', value: 5.75 },
      { showValue: '5h 50min', value: 5.83 },
      { showValue: '5h 55min', value: 5.92 },
      { showValue: '6h', value: 6 },
      { showValue: '6h 05min', value: 6.08 },
      { showValue: '6h 10min', value: 6.17 },
      { showValue: '6h 15min', value: 6.25 },
      { showValue: '6h 20min', value: 6.33 },
      { showValue: '6h 25min', value: 6.42 },
      { showValue: '6h 30min', value: 6.5 },
      { showValue: '6h 35min', value: 6.58 },
      { showValue: '6h 40min', value: 6.67 },
      { showValue: '6h 45min', value: 6.75 },
      { showValue: '6h 50min', value: 6.83 },
      { showValue: '6h 55min', value: 6.92 },
      { showValue: '7h', value: 7 },
      { showValue: '7h 05min', value: 7.08 },
      { showValue: '7h 10min', value: 7.17 },
      { showValue: '7h 15min', value: 7.25 },
      { showValue: '7h 20min', value: 7.33 },
      { showValue: '7h 25min', value: 7.42 },
      { showValue: '7h 30min', value: 7.5 },
      { showValue: '7h 35min', value: 7.58 },
      { showValue: '7h 40min', value: 7.67 },
      { showValue: '7h 45min', value: 7.75 },
      { showValue: '7h 50min', value: 7.83 },
      { showValue: '7h 55min', value: 7.92 },
      { showValue: '8h', value: 8 },
    ];
  }

  private LoadFittingsTimeOptions() {
    this.timeOptions = [
      { showValue: '0min', value: 0 },
      { showValue: '15min', value: 0.25 },
      { showValue: '30min', value: 0.5 },
      { showValue: '45min', value: 0.75 },
      { showValue: '1h', value: 1 },
      { showValue: '1h 15min', value: 1.25 },
      { showValue: '1h 30min', value: 1.5 },
      { showValue: '1h 45min', value: 1.75 },
      { showValue: '2h', value: 2 },
      { showValue: '2h 15min', value: 2.25 },
      { showValue: '2h 30min', value: 2.5 },
      { showValue: '2h 45min', value: 2.75 },
      { showValue: '3h', value: 3 },
      { showValue: '3h 15min', value: 3.25 },
      { showValue: '3h 30min', value: 3.5 },
      { showValue: '3h 45min', value: 3.75 },
      { showValue: '4h', value: 4 },
      { showValue: '4h 15min', value: 4.25 },
      { showValue: '4h 30min', value: 4.5 },
      { showValue: '4h 45min', value: 4.75 },
      { showValue: '5h', value: 5 },
      { showValue: '5h 15min', value: 5.25 },
      { showValue: '5h 30min', value: 5.5 },
      { showValue: '5h 45min', value: 5.75 },
      { showValue: '6h', value: 6 },
      { showValue: '6h 15min', value: 6.25 },
      { showValue: '6h 30min', value: 6.5 },
      { showValue: '6h 45min', value: 6.75 },
      { showValue: '7h', value: 7 },
      { showValue: '7h 15min', value: 7.25 },
      { showValue: '7h 30min', value: 7.5 },
      { showValue: '7h 45min', value: 7.75 },
      { showValue: '8h', value: 8 },
    ];
  }

  updateGroupName(group) {
    this.serviceType.GroupName =
      group.value && group.value.value ? group.value.value : group.value;
  }

  delete() {
    this.confirmationService.confirm({
      key: 'add_edit_services',
      rejectLabel: this.translate.instant('general.no'),
      acceptLabel: this.translate.instant('general.yes'),
      header: this.translate.instant(
        'bikeshop.service_types.delete_serviceType_header',
      ),
      message: this.translate.instant(
        'bikeshop.service_types.delete_serviceType',
      ),
      accept: () => {
        this.deleteLoading = true;
        this.partnerService
          .saveServiceType({
            ...this.serviceType,
            IsActive: false,
          })
          .subscribe((res) => {
            this.deleteLoading = false;
            this.closeSidePanel.emit();
          });
      },
    });
  }

  saveEdit() {
    this.saveLoading = true;
    this.busy = true;
    let checklistItems = this.checklist
      .filter((item) => {
        return item.Enabled;
      })
      .map((item) => {
        return {
          ID: 0,
          ChecklistItemID: item.ID,
          TypeID: this.serviceType.ID,
        };
      });
    let linkedTechnicians = this.technicians
      .filter((i) => {
        return i.Enabled;
      })
      .map((technician) => {
        return {
          ServiceTypeID: this.serviceType.ID,
          TechnicianID: technician.ID,
        };
      });

    this.partnerService
      .saveServiceType({
        ...this.serviceType,
        DefaultChecklistItems: checklistItems,
        Hours: this.duration.value,
      })
      .subscribe(
        (res) => {
          this.busy = false;
          this.saveLoading = false;

          this.messageService.add({
            key: 'bottom-center',
            detail: this.translate.instant(
              this.isFitting
                ? 'bikeshop.service_types.messages.fitting_updated'
                : 'bikeshop.service_types.messages.service_types_updated',
            ),
          });
        },
        (err) => {
          this.busy = false;
          this.saveLoading = false;
        },
      );
  }

  saveAdd() {
    this.saveLoading = true;
    let checklistItems = this.checklist
      .filter((item) => {
        return item.Enabled;
      })
      .map((item) => {
        return {
          ID: 0,
          ChecklistItemID: item.ID,
          TypeID: this.serviceType.ID,
        };
      });
    this.busy = true;

    this.partnerService
      .saveServiceTypeV2({
        ServiceTypeConfig: {
          ...this.serviceType,
          DefaultChecklistItems: checklistItems,
          Hours: this.duration.value,
          PartnerID: this.partnerId,
          IsActive: true,
          TechnicianLinked: true,
          Radius: 0,
        },
        ServiceSKU: this.newSku && this.newSku.SKU ? this.newSku.SKU : '', //this.linkedSKUs[this.serviceSKUPos] ? this.linkedSKUs[this.serviceSKUPos].SKU : '',
      })
      .subscribe((res) => {
        // let linkedTechnicians = this.technicians
        //   .filter((i) => {
        //     return i.Enabled;
        //   })
        //   .map((technician) => {
        //     return {
        //       ServiceTypeID: res.ID,
        //       TechnicianID: technician.ID,
        //     };
        //   });

        // this.serviceRequest
        //   .saveTechniciansForServiceType(linkedTechnicians)
        //   .subscribe((result) => {
        //     this.messageService.add({ key: "bottom-center", detail: this.translate.instant(this.isFitting ? 'bikeshop.service_types.messages.fitting_added' : 'bikeshop.service_types.messages.service_type_added') });
        //     this.busy = false;
        //     this.saveLoading = false;
        //     this.closeSidePanel.emit();
        //   });
        this.messageService.add({
          key: 'bottom-center',
          detail: this.translate.instant(
            this.isFitting
              ? 'bikeshop.service_types.messages.fitting_added'
              : 'bikeshop.service_types.messages.service_type_added',
          ),
        });
        this.busy = false;
        this.saveLoading = false;
        this.closeSidePanel.emit();
      });

    if (this.linkedSKUs[this.serviceSKUPos] !== this.oldServiceSKU) {
      const replacedSKU = this.linkedSKUs.find(
        (e) => e.SKU === this.linkedSKUs[this.serviceSKUPos],
      );

      const obj = {
        NewSku: this.linkedSKUs[this.serviceSKUPos].SKU,
        OldSKU: this.oldServiceSKU ? this.oldServiceSKU.SKU : '',
        ServiceTypeID: this.serviceType.ID,
      };

      if (replacedSKU) {
        this.partnerService.setServiceSKU(obj).subscribe((result) => { });
      } else {
        this.partnerService.setNewServiceSKU(obj).subscribe((result) => { });
      }
    }
  }

  checkSave() {
    if (this.editing) {
      //this.categoryError = !this.category;
      this.nameError = !this.serviceType.ServiceTypeDescription;
      this.durationError = !this.duration;
      this.costError =
        this.serviceType.Cost === null || this.serviceType.Cost.length === 0;
      if (
        !this.categoryError &&
        !this.nameError &&
        !this.durationError &&
        !this.costError
      ) {
        this.saveEdit();
      }
    } else {
      //this.categoryError = !this.category;
      this.nameError = !this.serviceType.ServiceTypeDescription;
      this.durationError = !this.duration;
      this.costError =
        this.serviceType.Cost === null || this.serviceType.Cost.length === 0;
      if (
        !this.categoryError &&
        !this.nameError &&
        !this.durationError &&
        !this.costError
      ) {
        this.saveAdd();
      }
    }
  }

  selectTab(tab) {
    this.selectedTab = tab;
    if (this.selectedTab === 2) {
    } else if (this.selectedTab === 3) {
      this.checklistService
        .getPartnerChecklistv2(
          this.helpersService.getPartnerId(),
          this.serviceType.ID,
        )
        .subscribe((checklist) => {
          let ids =
            this.serviceType && this.serviceType.DefaultChecklistItems
              ? this.serviceType.DefaultChecklistItems.map((item) => {
                return item.ChecklistItemID;
              })
              : [];
          this.checklist = checklist.map((item) => {
            if (ids.indexOf(item.id) > -1) {
              item.Enabled = true;
            }

            return item;
          });
          this.checklist.forEach((x) => {
            if (x.mandatoryForAllServices) {
              x.Enabled = true;
            }
          });
          this.checklist.forEach((x) => {
            if (x.mandatory) {
              x.Mandatory = true;
            }
          });
        });
    }
  }

  checkTechValidation(technician) {
    //At least one technician must be linked to a service types...flaw in the BE
    let linkedTechnicians = this.technicians.filter((i) => {
      return i.Enabled;
    });
    if (linkedTechnicians.length === 0) {
      this.busy = true;
      this.confirmationService.confirm({
        rejectVisible: false,
        acceptLabel: this.translate.instant('general.ok'),
        header: this.translate.instant('messages.no_technicians_linked'),
        message: this.translate.instant(
          'messages.no_technicians_linked_message',
        ),
        accept: () => { },
      });
      setTimeout(() => {
        technician.Enabled = true;
        this.busy = false;
      }, 100);
    } else {
      if (this.serviceType.ID) {
        if (technician.Enabled) {
          this.serviceRequest
            .linkTechniciansForServiceType({
              ServiceTypeID: this.serviceType.ID,
              TechnicianID: technician.ID,
            })
            .subscribe((res) => {
              this.messageService.add({
                key: 'bottom-center',
                detail: this.translate.instant(
                  this.isFitting
                    ? 'bikeshop.service_types.messages.fitter_linked'
                    : 'bikeshop.service_types.messages.technician_linked',
                ),
              });
            });
        } else {
          this.serviceRequest
            .unlinkTechniciansForServiceType({
              ServiceTypeID: this.serviceType.ID,
              TechnicianID: technician.ID,
            })
            .subscribe((res) => {
              this.messageService.add({
                key: 'bottom-center',
                detail: this.translate.instant(
                  this.isFitting
                    ? 'bikeshop.service_types.messages.fitter_unlinked'
                    : 'bikeshop.service_types.messages.technician_unlinked',
                ),
              });
            });
        }
      }
    }
  }

  saveTechnicians() {
    let linkedTechnicians = this.technicians
      .filter((i) => {
        return i.Enabled;
      })
      .map((technician) => {
        return {
          ServiceTypeID: this.serviceType.ID,
          TechnicianID: technician.ID,
        };
      });

    this.serviceRequest
      .saveTechniciansForServiceType(linkedTechnicians)
      .subscribe((result) => {
        this.messageService.add({
          key: 'bottom-center',
          detail: this.translate.instant(
            this.isFitting
              ? 'bikeshop.service_types.messages.fitters_updated'
              : 'bikeshop.service_types.messages.technicians_updated',
          ),
        });
      });
  }

  toggleAll() {
    if (this.allTech) {
      this.technicians = this.technicians.map((technician) => {
        technician.Enabled = true;
        return technician;
      });
    } else {
      this.technicians = this.technicians.map((technician) => {
        technician.Enabled = false;
        return technician;
      });
      //Leave 1 technician as enabled
      if (this.technicians && this.technicians.length > 0) {
        this.technicians[0].Enabled = true;
      }
    }
    this.saveTechnicians();
  }

  searchProducts(event) {
    var results = this.products.filter(function (product) {
      return (
        product.SKU.toLowerCase().indexOf(event.query.toLowerCase()) > -1 ||
        product.Name.toLowerCase().indexOf(event.query.toLowerCase()) > -1 ||
        (product.SystemSKU !== null &&
          product.SystemSKU.toLowerCase().indexOf(event.query.toLowerCase()) >
          -1) ||
        (product.ManufacturerSKU !== null &&
          product.ManufacturerSKU.toLowerCase().indexOf(
            event.query.toLowerCase(),
          ) > -1)
      );
    });
    results = JSON.parse(JSON.stringify(results)).map((product) => {
      product.InternalProductID = JSON.parse(JSON.stringify(product)).ID;
      product.ID = 0;
      product.Quantity = 1;
      delete product.PartnerID;
      return product;
    });

    if (results.length > 0) {
      this.searchResult = results;
    } else {
      this.searchExternal(event);
    }
  }

  searchExternal(event) {
    this.productsService
      .searchProduct(this.helpersService.getPartnerId(), event.query)
      .subscribe((results) => {
        this.searchResult = results.map((item) => {
          return {
            ID: item.ID,
            SKU: item.Description,
            Name: item.Data,
            Quantity: 1,
          };
        });
      });
  }

  addSku() {
    this.newSku = { SKU: '', Quantity: 1 };
  }

  linkSku(sku) {
    if (this.serviceType.ID) {
      let request = {
        ServiceTypeID: this.serviceType.ID,
        SKU: sku.SKU,
        Quantity: sku.Quantity,
      };
      this.partnerService
        .linkSkuToServiceType(request, this.helpersService.getPartnerId())
        .subscribe((skus) => {
          this.linkedSKUs = skus;
          this.newSku = null;
          if (this.linkedSKUs && this.linkedSKUs.length > 0) {
            if (!this.serviceType.OverrideSKUPrice) {
              this.serviceType.Cost = 0;
              this.linkedSKUs.map((x) => {
                this.serviceType.Cost += x.Cost;
              });
            }
          }
        });
    } else {
      if (
        this.serviceType.ServiceTypeDescription === undefined ||
        this.serviceType.ServiceTypeDescription.length === 0
      ) {
        this.serviceType.ServiceTypeDescription = sku.Name;
      }
      this.productsService
        .searchInvoiceProduct(this.helpersService.getPartnerId(), sku.SKU)
        .subscribe((result) => {
          if (!this.serviceType.OverrideSKUPrice) {
            if (
              this.serviceType.Cost === undefined ||
              this.linkedSKUs.length === 0
            ) {
              this.serviceType.Cost = 0;
            }
            if (result && result.length > 0) {
              this.serviceType.Cost = this.partner.VATInclusive
                ? result[0].UnitPrice_IncludingTax
                : result[0].UnitPrice;
            }
          }
        });
    }
  }

  unlinkSku(sku) {
    this.linkedSKUs = this.linkedSKUs.filter((x) => {
      return x.SKU !== sku.SKU;
    });
    let request = {
      ServiceTypeID: this.serviceType.ID,
      SKU: sku.SKU,
      Quantity: 0,
    };
    this.partnerService
      .unlinkSkuFromServiceType(request, this.helpersService.getPartnerId())
      .subscribe((skus) => {
        this.linkedSKUs = skus;
        if (this.linkedSKUs && this.linkedSKUs.length > 0) {
          if (!this.serviceType.OverrideSKUPrice) {
            this.serviceType.Cost = 0;
            this.linkedSKUs.map((x) => {
              this.serviceType.Cost += x.Cost;
            });
          }
        }
      });
  }

  updateChecklist(event) {
    console.log(event);
    if (event.Enabled) {
      this.partnerService
        .linkServiceTypeChecklist({
          TypeID: this.serviceType.ID,
          ChecklistItemID: event.id,
          Mandatory: false,
        })
        .subscribe((res) => {
          this.messageService.add({
            key: 'bottom-center',
            detail: this.translate.instant(
              'bikeshop.service_types.messages.checklist_item_linked',
            ),
          });
        });
    } else {
      this.partnerService
        .unlinkServiceTypeChecklist({
          TypeID: this.serviceType.ID,
          ChecklistItemID: event.id,
          Mandatory: null,
        })
        .subscribe((res) => {
          this.messageService.add({
            key: 'bottom-center',
            detail: this.translate.instant(
              'bikeshop.service_types.messages.checklist_item_unlinked',
            ),
          });
        });
    }

    let checklistItems = this.checklist
      .filter((item) => {
        return item.Enabled;
      })
      .map((item) => {
        return {
          ID: 0,
          ChecklistItemID: item.ID,
          TypeID: this.serviceType.ID,
          Mandatory: item.Mandatory,
        };
      });
    this.serviceType.DefaultChecklistItems = checklistItems;
  }

  updateMandatoryChecklist(event) {
    console.log(event);
    if (event.Mandatory) {
      this.partnerService
        .linkServiceTypeChecklist({
          TypeID: this.serviceType.ID,
          ChecklistItemID: event.id,
          Mandatory: true,
        })
        .subscribe((res) => {
          this.messageService.add({
            key: 'bottom-center',
            detail: this.translate.instant(
              'bikeshop.service_types.messages.checklist_item_linked',
            ),
          });
        });
    } else {
      this.partnerService
        .unlinkServiceTypeChecklist({
          TypeID: this.serviceType.ID,
          ChecklistItemID: event.id,
          Mandatory: false,
        })
        .subscribe((res) => {
          this.messageService.add({
            key: 'bottom-center',
            detail: this.translate.instant(
              'bikeshop.service_types.messages.checklist_item_unlinked',
            ),
          });
        });
    }

    let checklistItems = this.checklist
      .filter((item) => {
        return item.Enabled;
      })
      .map((item) => {
        return {
          ID: 0,
          ChecklistItemID: item.ID,
          TypeID: this.serviceType.ID,
          Mandatory: item.Mandatory,
        };
      });
    this.serviceType.DefaultChecklistItems = checklistItems;
  }

  checkOnlineBooking(event) {
    if (event.checked) {
      //this.serviceType.IsFitting = false;
    }
  }

  checkFitting(event) {
    if (event.checked) {
      //this.serviceType.Show = false;
    }
  }


  selectOverrideTab(tab) {
    this.selectedOverrideTab = tab;
  }

  resetOverrides() {
    this.forSpecificDate = false;
    this.forSpecificDay = false;
    this.specificDay = null;
    this.specificDate = '';
    this.startTime = '';
    this.endTime = '';
  }

  saveOverride() {
    this.startTime = new Date(this.startTime).toTimeString().substring(0,5);
    this.endTime = new Date(this.endTime).toTimeString().substring(0,5);  
    this.serviceRequest
      .saveOverride(this.partnerId, {
        ServiceTypeID: this.serviceType.ID,
        ForSpecificDay: this.forSpecificDay,
        ForSpecificDate: this.forSpecificDate,
        SpecificDay: this.specificDay ? this.specificDay.value : "",
        SpecificDate: this.specificDate,
        StartTime: this.startTime,
        EndTime: this.endTime,
      })
      .subscribe(
        (res) => {
          this.resetOverrides();
          this.getOverrides();
          this.busy = false;
          this.saveLoading = false;
          this.messageService.add({
            key: 'bottom-center',
            detail: this.translate.instant(
              this.isFitting
                ? 'bikeshop.service_types.messages.fitting_updated'
                : 'bikeshop.service_types.messages.service_types_updated',
            ),
          });
        },
        (err) => {
          this.busy = false;
          this.saveLoading = false;
        },
      );
  }

  getOverrides() {
    this.serviceRequest
      .getOverride(this.partnerId, this.serviceType.ID)
      .subscribe(
        (res) => {
          console.log(res);
          this.configuredOverrides = res;
          this.configuredOverrides.forEach((item) => {
            if (item.forSpecificDay) {
              item.specificDay = this.daysOfWeek.find(x => x.value == item.specificDay).label;
            }
          });

        },
        (err) => {
          this.busy = false;
          this.saveLoading = false;
        },
      );
  }

  deleteOverride(overrideID) {
    this.serviceRequest
      .deleteOverride(this.partnerId, overrideID.id)
      .subscribe(
        (res) => {
          this.getOverrides();
        },
        (err) => {
          this.busy = false;
          this.saveLoading = false;
        },
      );
  }

  hasSpecificDay() {
    return this.configuredOverrides.findIndex(x => x.forSpecificDay == true) == -1
  }

  hasSpecificDate() {
    return this.configuredOverrides.findIndex(x => x.forSpecificDate == true) == -1
  }
}
